/* eslint-disable */
import App from './apps/FlashAlertApp.vue'
import VueAppManager from '@services/VueAppManager'
import i18n from '@utils/i18n'

document.addEventListener('turbo:load', () => {
  VueAppManager.CreateManagedApp({
    key: 'flash-alert-vue-target',
    component: App,
    mountTarget: '#flash-alert-vue-target',
    // The kit toast (VueToastr) translates its Dismiss aria-label.
    configureApp: (app) => app.use(i18n),
  })
})
